import React from 'react';
import { STATUS_MAP, LICENSE_OPTIONS } from '../employeeConstants';
import { FilterDropdown } from './FilterDropdown';

/**
 * EmployeeFilters Component - Renders the dropdown filter bar.
 */
export function EmployeeFilters({ 
    visible,
    filterStatus, setFilterStatus,
    filterCategory, setFilterCategory,
    filterWorker, setFilterWorker,
    filterLicense, setFilterLicense,
    filterVehicle = [], setFilterVehicle = () => {},
    categories,
    employees,
    vehicles = [],
    view
}) {
    if (!visible) return null;

    const toggleFilter = (list, setList, value) => {
        const valStr = String(value);
        if (list.includes(valStr)) {
            setList(list.filter(item => item !== valStr));
        } else {
            setList([...list, valStr]);
        }
    };

    const selectAll = (setList, options) => {
        setList(options.map(o => String(o.value)));
    };

    const selectNone = (setList) => {
        setList([]);
    };

    // Prepare options
    const statusOptions = Object.entries(STATUS_MAP).map(([key, cfg]) => ({
        label: cfg.label,
        value: key
    }));

    const roleOptions = [
        { label: 'Keine Rolle', value: 'null' },
        ...categories.map(c => ({ label: c.name, value: c.id }))
    ];

    const workerOptions = employees.map(e => ({ label: e.name, value: e.id }));

    const vehicleOptions = vehicles.map(v => ({ 
        label: `${v.internal_name || '—'} (${v.license_plate || '—'})`, 
        value: v.id 
    }));

    const licenseOptions = [
        { label: 'Kein Führerschein', value: 'no_license' },
        ...LICENSE_OPTIONS.map(lic => ({ label: lic, value: lic }))
    ];

    return (
        <div className="employee-toolbar-filters">
            <div className="filter-dropdown-row" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                {/* Status Filter (Calendar only) */}
                {view === 'calendar' && (
                    <FilterDropdown 
                        label="Status"
                        icon="🚥"
                        options={statusOptions}
                        selectedValues={filterStatus}
                        onToggle={(val) => toggleFilter(filterStatus, setFilterStatus, val)}
                        onSelectAll={() => selectAll(setFilterStatus, statusOptions)}
                        onSelectNone={() => selectNone(setFilterStatus)}
                    />
                )}

                {/* Category Filter */}
                {view !== 'kolonnen' && (
                    <FilterDropdown 
                        label="Rollen"
                        icon="🏷️"
                        options={roleOptions}
                        selectedValues={filterCategory}
                        onToggle={(val) => toggleFilter(filterCategory, setFilterCategory, val)}
                        onSelectAll={() => selectAll(setFilterCategory, roleOptions)}
                        onSelectNone={() => selectNone(setFilterCategory)}
                    />
                )}

                {/* Worker Filter */}
                <FilterDropdown 
                    label="Mitarbeiter"
                    icon="👤"
                    options={workerOptions}
                    selectedValues={filterWorker}
                    onToggle={(val) => toggleFilter(filterWorker, setFilterWorker, val)}
                    onSelectAll={() => selectAll(setFilterWorker, workerOptions)}
                    onSelectNone={() => selectNone(setFilterWorker)}
                />

                {/* Vehicle Filter (Kolonnen only) */}
                {view === 'kolonnen' && (
                    <FilterDropdown 
                        label="Fahrzeuge"
                        icon="🚚"
                        options={vehicleOptions}
                        selectedValues={filterVehicle}
                        onToggle={(val) => toggleFilter(filterVehicle, setFilterVehicle, val)}
                        onSelectAll={() => selectAll(setFilterVehicle, vehicleOptions)}
                        onSelectNone={() => selectNone(setFilterVehicle)}
                    />
                )}

                {/* License Filter (Non-calendar, Non-kolonnen) */}
                {view !== 'calendar' && view !== 'kolonnen' && (
                    <FilterDropdown 
                        label="Führerschein"
                        icon="🪪"
                        options={licenseOptions}
                        selectedValues={filterLicense}
                        onToggle={(val) => toggleFilter(filterLicense, setFilterLicense, val)}
                        onSelectAll={() => selectAll(setFilterLicense, licenseOptions)}
                        onSelectNone={() => selectNone(setFilterLicense)}
                    />
                )}
            </div>
        </div>
    );
}
